import {DatePipe, DecimalPipe, registerLocaleData} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';

import localeCs from '@angular/common/locales/cs';
import localeEn from '@angular/common/locales/en';
import {Injectable, NgModule} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatStepperIntl} from '@angular/material/stepper';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import '@extensions/@all.extension';
import {FuseProgressBarModule, FuseSidebarModule} from '@fuse/components';

import {FuseModule} from '@fuse/fuse.module';
import {FuseSharedModule} from '@fuse/shared.module';
import {ErrorInterceptorProvider} from '@interceptors/error.interceptor';
import {LanguageInterceptorProvider} from '@interceptors/language.interceptor';
import {TranslateModule} from '@ngx-translate/core';
import {GoogleChartComponent, GoogleChartsModule, ScriptLoaderService} from 'angular-google-charts';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {QRCodeModule} from 'angularx-qrcode';
import {AppRoutingModule} from 'app/app-routing.module';

import {AppComponent} from 'app/app.component';
import {CoreModule} from 'app/core/core.module';
import {UserInfoModule} from 'app/core/userInfo.module';

import {fuseConfig} from 'app/fuse-config';
import {LayoutModule} from 'app/layout/layout.module';
import {ErrorDialogModule} from 'app/main/@error-dialog/error-dialog.module';
import {BlankPageComponent} from 'app/main/blank-page/blank-page.component';
import 'hammerjs';

registerLocaleData(localeCs);
registerLocaleData(localeEn);

@Injectable({providedIn: 'root'})
export class MyMatStepperIntl extends MatStepperIntl {
    optionalLabel = '';
}

@NgModule({
    declarations: [
        AppComponent,
        BlankPageComponent,
    ],
    providers: [
        DatePipe,
        DecimalPipe,
        GoogleChartComponent,
        ScriptLoaderService,
        {provide: MatStepperIntl, useClass: MyMatStepperIntl},

        LanguageInterceptorProvider,
        ErrorInterceptorProvider
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        UserInfoModule,
        CoreModule.forRoot(),
        HttpClientModule,
        AppRoutingModule,
        TranslateModule.forRoot(),
        SimpleNotificationsModule.forRoot({
            timeOut: 7000
        }),

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,

        // App modules
        LayoutModule,
        QRCodeModule,
        GoogleChartsModule.forRoot({version: '48', safeMode: true}),

        // MatDialog
        MatDialogModule,
        ErrorDialogModule,
    ],
    exports: [],
    bootstrap: [
        AppComponent,
    ],
})
export class AppModule {
}
